import { EmRouteConfig } from 'emrn-navigation';
import { Invite } from './Invite';
import { InviteProcess } from './InviteProcess';
import { InviteRanking } from './inviteRanking';
import { WardRecord } from './wardRecord';

/**
 * 默认路由，根据`page`参数找不到页面时会打开该页面
 */
export const defaultRouteName = 'Invite';

/**
 * 获取路由集合
 */
export function getRoutes(): EmRouteConfig[] {
  return [
    { routeName: 'Invite', screen: Invite },
    { routeName: 'WardRecord', screen: WardRecord }, // 奖励记录
    { routeName: 'InviteRanking', screen: InviteRanking }, // 邀请记录
    { routeName: 'InviteProcess', screen: InviteProcess }, // 邀请记录
  ];
}
